<script setup lang="ts">
import type { FormKitFrameworkContext } from '@formkit/core'
import InputText from 'primevue/inputtext'

const props = defineProps<{
  context: FormKitFrameworkContext
}>()

async function onUpdated(value?: string | undefined) {
  await props.context.node.input(value)
}
</script>

<template>
  <InputText v-bind="context.attrs" :model-value="context.value" @update:model-value="onUpdated" />
</template>
